import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .top {
    z-index: 10000;
  }
`
export const MultiOptionWrapper = styled.div`
  label {
    display: inline-flex;
  }

  .field {
    display: flex;
    width: 100% !important;
  }
`
